export const languageSettings = [
  {
    key: "mhapp",
    lan: "mr",
  },
  {
    key: "mwcd",
    lan: "mr",
  },
  {
    key: "localhost",
    lan: "mr",
  },
];
